import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Section, Overlay, Container } from '../../common';

const CalendarFull = ({ page, sanity }) => {
  const { colors, form } = sanity;

  return (
    <Section idName="calendar-full" padding="none">
      <div className="relative w-full">
        {/* Background Image + Overlay */}
        <div className="absolute inset-0">
          <GatsbyImage
            image={form?.bgImg?.asset?.gatsbyImageData}
            alt={form?.bgImg?.alt}
            className="object-cover w-full h-full"
            loading="eager"
          />
          <Overlay
            isGradient
            bgColor={colors?.neutral?.default}
            bgColorHover={colors?.neutral?.dark}
            bgColorStart={colors?.neutral?.dark}
            bgColorMid={colors?.neutral?.default}
            bgColorEnd={colors?.neutral?.light}
          />
        </div>

        {/* Calendar Container */}
        <Container padding="none" classes="relative w-full max-w-7xl px-4 lg:px-0 py-24 mx-auto">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden w-full h-[1025px] sm:h-[700px] md:h-[800px] lg:h-[825px]">
            <iframe
              src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ1c5woHVdOMFcPM2oYHeTNsNZPI54N0xfy_Jv36-TDcfk2LrSJYUdrVVH3FCdL8EKHMPgmKmZQy?gv=true"
              className="w-full h-full"
              frameBorder="0"
              title="Google Calendar"
            />
          </div>
        </Container>
      </div>
    </Section>
  );
};

export { CalendarFull };
